import {
  PATH_NAME_HOME,
  ROUTE_NAME_MAIN_CATEGORY,
  ROUTE_NAME_SUB_CATEGORY,
} from '@/common/router.const'

export default [
  {
    path: '/',
    name: PATH_NAME_HOME,
    components: {
      homeLayout: () => import('@/views/home/HomeLayout'),
    },
    children: [
      {
        path: 'category/main',
        name: ROUTE_NAME_MAIN_CATEGORY,
        components: {
          category: () =>
            import(
              /* webpackChunkName: "MainCategory" */ '@/views/category/MainCategory'
            ),
        },
      },
      {
        path: 'category/sub',
        name: ROUTE_NAME_SUB_CATEGORY,
        components: {
          category: () =>
            import(
              /* webpackChunkName: "SubCategory" */ '@/views/category/SubCategory'
            ),
        },
        props: true,
      },
    ],
  },
]
